import { gql } from 'graphql-tag'

const checkQuestionFragment = gql`
  fragment CheckQuestionFragment on CheckQuestion {
    id
    type
    description
    station {
      id
    }
  }
`

// All chain-wide questions (station_id NULL) for the chain admin UI.
export const chainCheckQuestionsQuery = gql`
  query ChainCheckQuestions {
    chainCheckQuestions {
      ...CheckQuestionFragment
    }
  }
  ${checkQuestionFragment}
`

export const createChainCheckQuestionMutation = gql`
  mutation CreateChainCheckQuestion($type: CheckQuestionTypeEnum!, $description: String!) {
    createChainCheckQuestion(type: $type, description: $description) {
      ...CheckQuestionFragment
    }
  }
  ${checkQuestionFragment}
`

export const updateChainCheckQuestionMutation = gql`
  mutation UpdateChainCheckQuestion($id: ID!, $description: String!) {
    updateChainCheckQuestion(id: $id, description: $description) {
      ...CheckQuestionFragment
    }
  }
  ${checkQuestionFragment}
`

export const deleteChainCheckQuestionMutation = gql`
  mutation DeleteChainCheckQuestion($id: ID!) {
    deleteChainCheckQuestion(id: $id)
  }
`

// --- Station admin ---

// A station's own custom questions.
export const stationCheckQuestionsQuery = gql`
  query StationCheckQuestions($stationId: ID!) {
    stationCheckQuestions(stationId: $stationId) {
      ...CheckQuestionFragment
    }
  }
  ${checkQuestionFragment}
`

// A station's per-chain-question on/off toggle rows (no row = ON).
export const stationCheckQuestionSettingsQuery = gql`
  query StationCheckQuestionSettings($stationId: ID!) {
    stationCheckQuestionSettings(stationId: $stationId) {
      id
      active
      checkQuestion {
        id
      }
    }
  }
`

export const createStationCheckQuestionMutation = gql`
  mutation CreateStationCheckQuestion($type: CheckQuestionTypeEnum!, $description: String!, $stationId: ID!) {
    createStationCheckQuestion(type: $type, description: $description, stationId: $stationId) {
      ...CheckQuestionFragment
    }
  }
  ${checkQuestionFragment}
`

export const updateStationCheckQuestionMutation = gql`
  mutation UpdateStationCheckQuestion($id: ID!, $description: String!) {
    updateStationCheckQuestion(id: $id, description: $description) {
      ...CheckQuestionFragment
    }
  }
  ${checkQuestionFragment}
`

export const deleteStationCheckQuestionMutation = gql`
  mutation DeleteStationCheckQuestion($id: ID!) {
    deleteStationCheckQuestion(id: $id)
  }
`

export const setChainCheckQuestionActiveMutation = gql`
  mutation SetChainCheckQuestionActive($stationId: ID!, $checkQuestionId: ID!, $active: Boolean!) {
    setChainCheckQuestionActive(stationId: $stationId, checkQuestionId: $checkQuestionId, active: $active) {
      id
      active
      checkQuestion {
        id
      }
    }
  }
`
